export default {
  'order.QueryFailedPleaseTryAgain': '查詢失敗請重試',
  'order.paymentSuccessful': '支付成功',
  'order.ThePaymentIsSuccessfulPleaseReturnToWeChatToContinueTheOperation':
    '支付成功，請返回微信繼續操作',
  'order.FailedToGetOrderInformation': '獲取訂單信息失敗',
  'order.AlipayScanCodePayment': '支付寶掃碼付款',
  'order.ScanCodePayment': '掃碼付',
  'order.Cancel': '取消'
};
